// The /apply genre vocabulary (.design-specs/sources/apply/apply.html, `genreTree`): ~140 genres and sub-genres under
// 13 parents. Copied verbatim from the approved prototype; stored on the application as the names picked.

export const GENRE_TREE: Readonly<Record<string, readonly string[]>> = {
  "Rock": ["Rock", "Alternative Rock", "Indie Rock", "Hard Rock", "Classic Rock", "Southern Rock", "Garage Rock", "Psychedelic Rock", "Post-Rock", "Prog Rock", "Stoner Rock", "Surf Rock", "Grunge", "Shoegaze", "Math Rock", "Post-Punk", "Britpop"],
  "Punk & Emo": ["Punk", "Pop Punk", "Hardcore", "Post-Hardcore", "Melodic Hardcore", "Emo", "Midwest Emo", "Screamo", "Skate Punk", "Ska Punk", "Easycore"],
  "Metal": ["Metal", "Metalcore", "Deathcore", "Death Metal", "Black Metal", "Thrash Metal", "Doom Metal", "Progressive Metal", "Nu Metal", "Djent", "Power Metal", "Sludge"],
  "Pop": ["Pop", "Indie Pop", "Synth-pop", "Dream Pop", "Electropop", "Dance Pop", "Bedroom Pop", "Hyperpop", "K-Pop", "Art Pop", "Power Pop"],
  "Country": ["Country", "Americana", "Alt-Country", "Bluegrass", "Outlaw Country", "Country Pop", "Red Dirt", "Honky Tonk", "Western Swing"],
  "Folk": ["Folk", "Indie Folk", "Folk Rock", "Singer-Songwriter", "Acoustic", "Celtic"],
  "Hip Hop": ["Hip Hop", "Rap", "Trap", "Drill", "Boom Bap", "Conscious Hip Hop", "Alternative Hip Hop", "Cloud Rap", "Christian Hip Hop"],
  "R&B & Soul": ["R&B", "Alternative R&B", "Neo-Soul", "Soul", "Funk", "Motown", "Gospel"],
  "Electronic": ["Electronic", "House", "Deep House", "Techno", "Trance", "Drum & Bass", "Dubstep", "EDM", "Future Bass", "Synthwave", "Ambient", "Downtempo", "Lo-fi", "IDM", "Garage"],
  "Worship & Christian": ["Worship", "Christian", "Christian Rock", "CCM", "Southern Gospel"],
  "Jazz & Blues": ["Jazz", "Blues", "Delta Blues", "Blues Rock", "Bebop", "Jazz Fusion", "Smooth Jazz", "Swing", "Big Band"],
  "Latin & World": ["Latin", "Reggaeton", "Latin Pop", "Regional Mexican", "Cumbia", "Salsa", "Bachata", "Afrobeats", "Amapiano", "Reggae", "Dancehall", "Ska"],
  "Other": ["Experimental", "Instrumental", "Classical", "Cinematic", "Soundtrack", "Comedy", "Spoken Word", "Children's"],
};

export interface Genre {
  name: string;
  parent: string;
}

export const ALL_GENRES: readonly Genre[] = Object.entries(GENRE_TREE).flatMap(([parent, names]) =>
  names.map((name) => ({ name, parent })),
);

/** The quick-add row under an empty search (the prototype's own order). */
export const POPULAR_GENRES = [
  "Rock", "Pop", "Country", "Hip Hop", "Indie Rock", "Alternative Rock", "Worship", "Emo", "Metalcore", "Electronic",
] as const;

export const MAX_GENRES = 3;

/**
 * Genres matching a query: by name or parent, excluding ones already picked; names that START with the query rank
 * first; at most 8. An empty query matches nothing (the popular row shows instead).
 */
export function matchGenres(query: string, picked: readonly string[], limit = 8): Genre[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return ALL_GENRES.filter(
    (g) => !picked.includes(g.name) && (g.name.toLowerCase().includes(q) || g.parent.toLowerCase().includes(q)),
  )
    .map((g, i) => ({ g, i, starts: g.name.toLowerCase().startsWith(q) ? 0 : 1 }))
    .sort((a, b) => a.starts - b.starts || a.i - b.i)
    .slice(0, limit)
    .map((x) => x.g);
}
